import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79f3d130"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message-tab-container" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center mb-3" }
const _hoisted_3 = { class: "font-weight-bold" }
const _hoisted_4 = { class: "row form-group" }
const _hoisted_5 = { class: "col-lg-12 col-md-12 col-sm-12 form-control no-border" }
const _hoisted_6 = {
  for: "message-tab-subject",
  class: "d-block mb-0 small text-muted"
}
const _hoisted_7 = { class: "col-lg-12 col-md-12 col-sm-12 form-control no-border" }
const _hoisted_8 = {
  for: "message-tab-reference",
  class: "d-block mb-0 small text-muted"
}
const _hoisted_9 = { class: "mr-2 font-weight-normal" }
const _hoisted_10 = {
  key: 0,
  class: "theme-1"
}
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = { class: "badge badge-primary" }
const _hoisted_13 = { class: "ml-2" }
const _hoisted_14 = { class: "col-lg-12 col-md-12 col-sm-12 form-control no-border" }
const _hoisted_15 = {
  for: "message-tab-body",
  class: "d-block mb-0 small text-muted"
}
const _hoisted_16 = {
  class: "d-flex justify-content-end align-items-center mt-3",
  style: {"gap":"10px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_searchable_select = _resolveComponent("searchable-select")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_combo_recipients = _resolveComponent("combo-recipients")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_inner_loading = _resolveComponent("q-inner-loading")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t("communication.comMessage.newMessage")), 1),
      _createVNode(_component_q_toggle, {
        modelValue: _ctx.importantTag,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.importantTag) = $event)),
        color: "red",
        class: "tw-custom-toggle",
        label: _ctx.$t('communication.comMessage.important') || 'Important'
      }, null, 8, ["modelValue", "label"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("communication.comMessage.subjectLabel")), 1),
        _createVNode(_component_searchable_select, {
          "input-id": "message-tab-subject",
          outlined: "",
          "bottom-slots": "",
          modelValue: _ctx.subject,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.subject) = $event)),
          options: _ctx.subjectOptions,
          rules: [_ctx.isRequired],
          dense: "",
          "options-dense": ""
        }, {
          append: _withCtx(() => [
            (_ctx.subject)
              ? (_openBlock(), _createBlock(_component_q_icon, {
                  key: 0,
                  name: "cancel",
                  size: "xs",
                  class: "cursor-pointer",
                  onClick: [
                    _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
                    _cache[2] || (_cache[2] = ($event: any) => (_ctx.subject = null))
                  ]
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["modelValue", "options", "rules"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("communication.comMessage.referenceLabel")), 1),
        _createVNode(_component_q_select, {
          "input-id": "message-tab-reference",
          outlined: "",
          "use-input": "",
          multiple: "",
          modelValue: _ctx.selectedReference,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedReference) = $event)),
          options: _ctx.referenceOptions,
          onFilter: _ctx.filterRefFn,
          onClick: _withModifiers(_ctx.abortRefFilter, ["stop","prevent"]),
          dense: "",
          "options-dense": "",
          "emit-value": "",
          "map-options": ""
        }, {
          "selected-item": _withCtx((scope) => [
            (_ctx.getSelectedLabel(scope) && _ctx.getSelectedLabel(scope).context && _ctx.getSelectedLabel(scope).id)
              ? (_openBlock(), _createBlock(_component_q_chip, {
                  key: 0,
                  removable: "",
                  dense: "",
                  onRemove: ($event: any) => (scope.removeAtIndex(scope.index)),
                  tabindex: scope.tabindex,
                  color: "white",
                  "text-color": "primary",
                  class: "badge badge-primary d-flex",
                  onClick: _withModifiers(_ctx.abortRefFilter, ["stop","prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.getSelectedLabel(scope) && _ctx.getSelectedLabel(scope).context
                  ? _ctx.$t("communication.comMessage.".concat(_ctx.getSelectedLabel(scope).context))
                  : ''), 1),
                    _createTextVNode(" - " + _toDisplayString(_ctx.getSelectedLabel(scope) && _ctx.getSelectedLabel(scope).id ? _ctx.getSelectedLabel(scope).id : ''), 1)
                  ]),
                  _: 2
                }, 1032, ["onRemove", "tabindex", "onClick"]))
              : _createCommentVNode("", true)
          ]),
          option: _withCtx((scope) => [
            (_ctx.getSelectedLabel(scope) && _ctx.getSelectedLabel(scope).context && _ctx.getSelectedLabel(scope).id)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _withDirectives((_openBlock(), _createElementBlock("div", _mergeProps({
                    class: "border p-2",
                    key: _ctx.getSelectedLabel(scope),
                    clickable: ""
                  }, scope.itemProps), [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.getSelectedLabel(scope) && _ctx.getSelectedLabel(scope).context
                      ? _ctx.$t("communication.comMessage.".concat(_ctx.getSelectedLabel(scope).context))
                      : ''), 1),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getSelectedLabel(scope) && _ctx.getSelectedLabel(scope).id ? _ctx.getSelectedLabel(scope).id : ''), 1)
                    ])
                  ], 16)), [
                    [_directive_ripple],
                    [_directive_close_popup]
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          "no-option": _withCtx(() => [
            _createVNode(_component_q_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_item_section, { class: "text-grey" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("main.noResults")), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "options", "onFilter", "onClick"])
      ]),
      _createVNode(_component_combo_recipients, {
        ref: "comboRecipients",
        recipients: _ctx.recipientOptions,
        metadata: _ctx.selectedReference
      }, null, 8, ["recipients", "metadata"]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t("communication.comMessage.messageLabel") || "Message"), 1),
        _createVNode(_component_q_input, {
          "input-id": "message-tab-body",
          "data-testid": "textarea_testid",
          modelValue: _ctx.message,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.message) = $event)),
          outlined: "",
          type: "textarea",
          rows: 4
        }, null, 8, ["modelValue"])
      ])
    ]),
    _createVNode(_component_q_inner_loading, {
      showing: _ctx.isSending,
      label: _ctx.$t('communication.comMessage.waitSendMessageLabel'),
      "label-class": "text-blue",
      "label-style": "font-size: 1.1em"
    }, null, 8, ["showing", "label"]),
    _createElementVNode("div", _hoisted_16, [
      _createVNode(_component_q_btn, {
        class: "btn btn-primary w-auto",
        flat: "",
        push: "",
        label: _ctx.$t('communication.comMessage.sendBtn'),
        type: "submit",
        onClick: _ctx.sendMessage
      }, null, 8, ["label", "onClick"])
    ])
  ]))
}